(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chs-booking-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.chs-service-catalog').forEach((catalog) => {
  if (catalog.dataset.initialized) return;
  catalog.dataset.initialized = 'true';
  const grid = catalog.querySelector('.chs-booking-hub__grid');
  const cards = Array.from(grid.querySelectorAll('[data-service-card]'));
  if (Number(catalog.dataset.collectionCount) > cards.length) return;
  const studio = catalog.querySelector('[data-studio]');
  const service = catalog.querySelector('[data-service]');
  const sort = catalog.querySelector('[data-sort]');
  const count = catalog.querySelector('.chs-service-catalog__count');
  const empty = catalog.querySelector('.chs-service-catalog__empty');
  const all = catalog.querySelector('[data-view-all]');
  catalog.querySelector('.chs-service-catalog__controls').hidden = false;
  all.hidden = false;
  function update() {
    const ordered = cards.slice().sort((a,b) => {
      if (sort.value === 'name-asc') return a.dataset.name.localeCompare(b.dataset.name);
      if (sort.value === 'name-desc') return b.dataset.name.localeCompare(a.dataset.name);
      if (sort.value === 'price-asc') return Number(a.dataset.price)-Number(b.dataset.price) || Number(a.dataset.popular)-Number(b.dataset.popular);
      if (sort.value === 'price-desc') return Number(b.dataset.price)-Number(a.dataset.price) || Number(a.dataset.popular)-Number(b.dataset.popular);
      return Number(a.dataset.popular)-Number(b.dataset.popular);
    });
    let visible = 0;
    ordered.forEach(card => {
      card.hidden = Boolean((studio.value && !card.dataset.studios.split(',').includes(studio.value)) || (service.value && card.dataset.category !== service.value));
      if (!card.hidden) visible++;
      grid.append(card);
    });
    count.textContent = visible + ' ' + (visible === 1 ? catalog.dataset.countSingular : catalog.dataset.countLabel);
    empty.hidden = visible !== 0;
  }
  [studio,service,sort].forEach(input => input.addEventListener('change',update));
  function reset() { studio.value=''; service.value=''; sort.value='popular'; update(); }
  catalog.querySelector('[data-reset]').addEventListener('click',reset);
  all.addEventListener('click',() => { reset(); studio.focus({preventScroll:true}); catalog.querySelector('.chs-service-catalog__controls').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-careers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
 const link = event.target.closest('[data-careers-role]');
 if (!link) return;
 const root = link.closest('.chs-careers');
 const select = root.querySelector('select[name="contact[role]"]');
 if (select) { select.value = link.dataset.careersRole; select.focus({preventScroll:true}); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-events"]) return;
  try {
    
document.querySelectorAll('.chs-events__grid').forEach(grid => {
  const direction = grid.dataset.eventOrder === 'past' ? -1 : 1;
  [...grid.children].sort((a, b) => direction * (Number(a.dataset.eventStart || 0) - Number(b.dataset.eventStart || 0))).forEach(card => grid.append(card));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-home-brands"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
const button=event.target.closest('[data-logo-toggle]');if(!button)return;
const strip=button.closest('[data-logo-strip]');const paused=strip.dataset.paused!=='true';
strip.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-product-add-ons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeAddOns = (root) => {
      if (!root || root.dataset.chsAddonReady === 'true') return;
      root.dataset.chsAddonReady = 'true';

      root.querySelectorAll('[data-chs-addon-form]').forEach((form) => {
        const variant = form.querySelector('[data-chs-addon-variant]');
        const quantity = form.querySelector('[data-chs-addon-quantity]');
        const price = form.querySelector('[data-chs-addon-price]');
        const submit = form.querySelector('.chs-add-on-submit');
        const buttonLabel = form.querySelector('[data-chs-addon-button]');
        const status = form.querySelector('[data-chs-addon-status]');
        const defaultLabel = buttonLabel.textContent;

        variant?.addEventListener('change', () => {
          const option = variant.options[variant.selectedIndex];
          price.textContent = option.dataset.price || '';
          submit.disabled = option.disabled;
        });

        form.querySelector('[data-chs-quantity-minus]')?.addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
        });

        form.querySelector('[data-chs-quantity-plus]')?.addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          submit.disabled = true;
          status.textContent = '';

          try {
            const response = await fetch(form.action + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);

            buttonLabel.textContent = root.dataset.addedLabel;
            status.textContent = root.dataset.addedMessage;

            const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
            const cart = await cartResponse.json();
            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((count) => {
              count.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'chs-add-ons', cart } }));
          } catch (error) {
            status.textContent = error.message || root.dataset.errorMessage;
          } finally {
            window.setTimeout(() => {
              buttonLabel.textContent = defaultLabel;
              submit.disabled = variant.options[variant.selectedIndex]?.disabled || false;
            }, 1800);
          }
        });
      });
    };

    document.querySelectorAll('[data-chs-addon-section]').forEach(initializeAddOns);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-chs-addon-section]').forEach(initializeAddOns);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-service-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chs-poster-slideshow')) {
  customElements.define('chs-poster-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.slides = [...this.querySelectorAll('.chs-poster')];
      if (!this.slides.length) return;
      this.track = this.querySelector('.chs-poster__track');
      this.viewport = this.querySelector('.chs-poster__viewport');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.index = -1;
      this.animations = [];
      this.listeners = [];
      const listen = (target,type,fn,options) => {
        target.addEventListener(type,fn,options);
        this.listeners.push(() => target.removeEventListener(type,fn,options));
      };
      listen(this.previous,'click',()=>this.go(this.index-1));
      listen(this.next,'click',()=>this.go(this.index+1));
      listen(this,'keydown',event=>{
        if (event.ctrlKey || event.metaKey || event.altKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length-1 : this.index+(event.key === 'ArrowRight' ? 1 : -1);
        if (this.slides.some(slide=>slide.contains(document.activeElement))) this.next.focus();
        this.go(target);
      });
      listen(this.viewport,'pointerdown',event=>{
        if (!event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
        this.start={x:event.clientX,y:event.clientY,id:event.pointerId,target:event.target,time:event.timeStamp};
      });
      listen(this.viewport,'pointermove',event=>{
        if (!this.start || event.pointerId !== this.start.id) return;
        const dx=event.clientX-this.start.x,dy=event.clientY-this.start.y;
        if (!this.dragging) {
          if (Math.abs(dy)>10 && Math.abs(dy)>Math.abs(dx)) { this.start=null; return; }
          if (Math.abs(dx)<10 || Math.abs(dx)<Math.abs(dy)*1.2) return;
          this.animations.forEach(animation=>animation.cancel());
          this.slides.forEach(slide=>slide.classList.remove('is-leaving'));
          this.dragging=true;
          this.setAttribute('data-dragging','');
          this.track.setAttribute('aria-live','off');
          this.viewport.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        const width=this.viewport.clientWidth;
        this.dragOffset=Math.max(-width*.9,Math.min(width*.9,dx));
        const previewIndex=(this.index+(dx<0?1:-1)+this.slides.length)%this.slides.length;
        if (this.preview && this.preview!==this.slides[previewIndex]) { this.preview.classList.remove('is-preview'); this.preview.style.transform=''; }
        this.preview=this.slides[previewIndex];
        this.preview.classList.add('is-preview');
        this.slides[this.index].style.transform='translateX('+this.dragOffset+'px)';
        this.preview.style.transform='translateX('+(this.dragOffset+(dx<0?width:-width))+'px)';
      },{passive:false});
      const finishDrag=(event,cancelled=false)=>{
        if (!this.start || event.pointerId !== this.start.id) return;
        const offset=this.dragOffset||0;
        const width=this.viewport.clientWidth;
        const shouldChange=!cancelled && this.dragging && Math.abs(offset)>Math.max(40,Math.min(80,width*.12));
        if (this.dragging) {
          this.suppressClick=true;
          clearTimeout(this.clickTimer);
          this.clickTimer=setTimeout(()=>{this.suppressClick=false;},400);
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          const current=this.slides[this.index],preview=this.preview;
          current.style.transform='';
          if(preview){preview.style.transform='';preview.classList.remove('is-preview');}
          if(shouldChange)this.go(this.index+(offset<0?1:-1),offset);
          else if(!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.animations=[current.animate([{transform:'translateX('+offset+'px)'},{transform:'translateX(0)'}],{duration:180,easing:'ease-out'})];
          }
        }
        this.start=null;this.dragging=false;this.dragOffset=0;this.preview=null;
        this.removeAttribute('data-dragging');
        this.track.setAttribute('aria-live','polite');
      };
      listen(this.viewport,'pointerup',event=>finishDrag(event));
      listen(this.viewport,'pointercancel',event=>finishDrag(event,true));
      listen(this.viewport,'lostpointercapture',event=>{if(this.start && this.dragging)finishDrag(event,true);});
      listen(this.viewport,'click',event=>{
        if (!this.suppressClick) return;
        event.preventDefault();event.stopPropagation();this.suppressClick=false;
      },true);
      listen(this.viewport,'dragstart',event=>event.preventDefault());
      listen(window,'hashchange',()=>this.openHash());
      listen(document,'shopify:block:select',event=>{
        const index=this.slides.findIndex(slide=>slide.contains(event.target));
        if(index>=0)this.go(index);
      });
      this.setAttribute('data-ready','');
      this.go(0);
      this.openHash();
      this.cleanup=()=>{clearTimeout(this.clickTimer);this.animations.forEach(animation=>animation.cancel());this.listeners.forEach(remove=>remove());this.cleanup=null;};
    }
    disconnectedCallback(){this.cleanup?.();}
    openHash(){
      const hash=window.location.hash.slice(1);
      if(!hash)return;
      const index=this.slides.findIndex(slide=>[...slide.querySelectorAll('[id]')].some(el=>el.id===hash));
      if(index>=0)this.go(index);
    }
    go(index,dragOffset=0){
      const previous=this.index;
      const next=(index+this.slides.length)%this.slides.length;
      if(next===previous)return;
      this.animations.forEach(animation=>animation.cancel());
      this.slides.forEach(slide=>slide.classList.remove('is-leaving'));
      this.index=next;
      this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
      if(previous<0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const direction=index>previous?1:-1;
      const outgoing=this.slides[previous],incoming=this.slides[next];
      outgoing.classList.add('is-leaving');
      const options={duration:420,easing:'cubic-bezier(.25,.8,.25,1)'};
      this.animations=[outgoing.animate([{transform:'translateX('+dragOffset+'px)'},{transform:'translateX('+(-direction*100)+'%)'}],options),incoming.animate([{transform:'translateX('+(direction*this.viewport.clientWidth+dragOffset)+'px)'},{transform:'translateX(0)'}],options)];
      const outgoingAnimation=this.animations[0];
      outgoingAnimation.finished.then(()=>{outgoing.classList.remove('is-leaving');}).catch(()=>{});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chs-studio-booking-rules"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chs-studio-booking-rules')) {
    customElements.define('chs-studio-booking-rules', class extends HTMLElement {
      connectedCallback() {
        this.options = JSON.parse(this.querySelector('[data-booking-options]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-booking-variants]').textContent);
        this.staffIndex = this.options.findIndex(name => name.toLowerCase() === this.dataset.staffOption.trim().toLowerCase());
        this.productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"][data-update-url="true"]`);
        if (!this.productInfo || this.staffIndex < 0) return;
        this.productInfo.classList.add('chs-studio-booking');
        this.notice = this.querySelector('[data-booking-notice]');
        this.onChange = event => {
          if (event.target.closest('variant-selects')) this.sync(true);
        };
        this.productInfo.addEventListener('change', this.onChange, true);
        this.onBook = event => {
          if (this.pending && event.target.closest('#appointo-btn, .product-form__submit')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.productInfo.addEventListener('click', this.onBook, true);
        this.observer = new MutationObserver(() => this.sync(false));
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
        this.calendarObserver = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('select, option') || node.querySelector('select'))))) this.syncCalendarOptions();
        });
        this.calendarObserver.observe(document.body, { childList: true, subtree: true });
        this.syncCalendarOptions();
        this.sync(false);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange, true);
        this.productInfo?.removeEventListener('click', this.onBook, true);
        this.observer?.disconnect();
        this.calendarObserver?.disconnect();
        this.notice?.remove();
      }

      syncCalendarOptions() {
        const unavailable = new Set(this.variants.filter(variant => !variant.available).map(variant => String(variant.id)));
        document.querySelectorAll('select option').forEach(option => {
          if (unavailable.has(option.value)) {
            option.disabled = true;
            option.hidden = true;
          }
        });
      }

      sync(announce) {
        const picker = this.productInfo.querySelector('variant-selects');
        if (!picker) return;
        const groups = [...picker.querySelectorAll('.product-form__input')];
        if (groups.length !== this.options.length) return;
        const values = groups.map(group => group.querySelector('input:checked, select')?.value);
        const staffGroup = groups[this.staffIndex];
        staffGroup.setAttribute('data-team-options', '');
        const roomNotes = { 'studio a': this.dataset.studioANote, 'studio b': this.dataset.studioBNote };
        groups.forEach((group, index) => {
          if (this.options[index].toLowerCase() !== 'studio') return;
          group.querySelectorAll('input[type="radio"]').forEach(input => {
            const note = roomNotes[input.value.toLowerCase()];
            const label = [...group.querySelectorAll('label')].find(item => item.htmlFor === input.id);
            const caption = label?.querySelector('.chs-variant-option__label');
            if (!caption || !note || caption.querySelector('.chs-variant-option__capacity')) return;
            const capacity = document.createElement('span');
            capacity.className = 'chs-variant-option__capacity';
            capacity.textContent = note;
            caption.append(capacity);
          });
        });
        const select = staffGroup.querySelector('select');
        const controls = [...staffGroup.querySelectorAll('input[type="radio"], option')];
        const allowed = new Set(this.variants.filter(variant => variant.options.every((value, index) => index === this.staffIndex || value === values[index])).map(variant => variant.options[this.staffIndex]));
        let changed = false;
        if (!allowed.has(values[this.staffIndex])) {
          const fallback = controls.find(control => allowed.has(control.value));
          controls.forEach(control => {
            if (select) {
              control.selected = control === fallback;
              control.toggleAttribute('selected', control === fallback);
            } else {
              control.checked = control === fallback;
            }
          });
          changed = Boolean(fallback);
          values[this.staffIndex] = fallback?.value;
        }
        controls.forEach(control => {
          const incompatible = !allowed.has(control.value);
          control.toggleAttribute('data-chs-incompatible', incompatible);
          control.disabled = incompatible;
          if (!select) {
            const label = [...staffGroup.querySelectorAll('label')].find(item => item.htmlFor === control.id);
            label?.toggleAttribute('data-chs-incompatible', incompatible);
          }
        });
        const variant = this.variants.find(item => item.options.every((value, index) => value === values[index]));
        this.pending = !variant || !variant.available;
        this.productInfo.classList.toggle('chs-studio-pending', this.pending);
        if (this.notice) {
          if (picker.nextElementSibling !== this.notice) picker.after(this.notice);
          this.notice.hidden = !this.pending;
          const alternate = this.notice.querySelector('[data-alternate-booking]');
          if (alternate) alternate.hidden = !this.pending || !values.includes('studio b');
        }
        if (announce && changed) this.querySelector('[data-booking-status]').textContent = values.filter(Boolean).join(' / ');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
